module.exports = __webpack_public_path__ + "static/media/task-list-approve.1847f726.svg";